import { render } from "./SkillBox.vue?vue&type=template&id=300c1b60&scoped=true&ts=true"
import script from "./SkillBox.vue?vue&type=script&lang=ts"
export * from "./SkillBox.vue?vue&type=script&lang=ts"

import "./SkillBox.vue?vue&type=style&index=0&id=300c1b60&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-300c1b60"]])

export default __exports__